import { render, staticRenderFns } from "./courseadd.vue?vue&type=template&id=e4156b54&scoped=true"
import script from "./courseadd.vue?vue&type=script&lang=js"
export * from "./courseadd.vue?vue&type=script&lang=js"
import style0 from "./courseadd.vue?vue&type=style&index=0&id=e4156b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_bsee5fwwgi4baxsb37pouy7wkq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4156b54",
  null
  
)

export default component.exports